/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import React from "react";
import { Button, Grid, IconButton, Paper, TextField, Tooltip } from "@material-ui/core";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import { downloadFileFromMongoDB } from "../../../utils/commonFunctions/downloadFileFromDatabase";
import { Suspense, useCallback, useEffect, useState } from "react";
import { LazyCustomPdfViewerDialog } from "../../pages";
import { generateFileURL } from "../../../utils/commonFunctions/generateFileURL";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { LazyCustomImageDialogWithTitle, LazyCustomPdfViewWithTitleDialog } from "..";
import generateImageUrl from "../../../utils/commonFunctions/imageUrl";
import ErrorIcon from "@material-ui/icons/Error";
import InputAdornment from "@mui/material/InputAdornment";
import { api } from "../../../utils/api";
/**
 * @param {{ informationFormData: any, employee_id?: string | null , employee_role?:string | null }} props
 */
const DynamicInformationForm = ({ informationFormData, employee_id = null, employee_role = null }) => {
	console.log("Informationcheckforconsole---->>>", informationFormData);
	const [eventName, setEventName] = useState("");
	const [eventDate, setEventDate] = useState(null);
	const [ssnVisibility, setSsnVisibility] = useState(false);
	const [actualSSNVisibility, setActualSSNVisibility] = useState(false);
	const [pdfProps, setPdfProps] = useState("");
	const [openPdfViewDialogProps, setOpenPdfViewDialogProps] = useState({
		openDialog: false
	});
	const [imageDialogProps, setImageDialogProps] = useState({
		openDialog: false,
		image: undefined
	});

	const handleImageDialogClose = useCallback(() => {
		setImageDialogProps(
			Object.assign({}, imageDialogProps, {
				openDialog: false
			})
		);
	}, [imageDialogProps]);

	const handlePdfViewDialogClose = useCallback(() => {
		setOpenPdfViewDialogProps(Object.assign({}, openPdfViewDialogProps, { openDialog: false }));
	}, [openPdfViewDialogProps]);

	const handlePdfViewDialogOpen = useCallback(() => {
		setOpenPdfViewDialogProps(Object.assign({}, openPdfViewDialogProps, { openDialog: true }));
	}, [openPdfViewDialogProps]);

	const handleViewDocumentClick = (file) => {
		if (file.mimetype === "image/png" || file.mimetype === "image/jpg" || file.mimetype === "image/jpeg") {
			const imageInstance = file;

			setImageDialogProps(
				Object.assign({}, imageDialogProps, {
					openDialog: true,
					image: generateImageUrl(imageInstance)
				})
			);
		}

		if (file.mimetype === "application/pdf") {
			handlePdfViewDialogOpen();
		}
	};

	const handleViewSSN = async (fieldName, ssn) => {
		console.log("SSN check for console--->>>", ssn);
		try {
			const viewSSNAddLogPayload = {
				member_id: employee_id,
				member_role: employee_role
			};
			const response = await api.viewSSNLog.viewSSNAddLog(viewSSNAddLogPayload);
			console.log("Rsponsecheck--->>>", response);
			if (response) {
				if (fieldName === "SSN") {
					setSsnVisibility((prev) => !prev);
				} else {
					setActualSSNVisibility((prev) => !prev);
				}
			}
		} catch (error) {
			console.error("Error viewing SSN or adding log:", error);
		}
	};

	// const formatSSN = (ssn, visible = false) => {
	// 	if (!ssn || typeof ssn !== "string") return "";
	// 	if (visible && ssn.match(/^\d{3}-\d{2}-\d{4}$/)) return ssn;
	// 	if (ssn.length >= 4) {
	// 		const last4 = ssn.slice(-4);
	// 		return `XXX-XX-${last4}`;
	// 	}
	// 	return "XXX-XX-XXXX";
	// };
	const formatSSN = (ssn, visible = false) => {
		if (!ssn || typeof ssn !== "string") return "";

		// when visible → always show original value
		if (visible) return ssn;

		// when hidden → mask last 4
		return `XXX-XX-${ssn.slice(-4)}`;
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handlePDFViewClick = () => {
		informationFormData.forEach((data) => {
			if (data.name === "event_document") {
				// console.log("data", data);
				if (data.value !== null || data.value === "") {
					if (data.value.mimetype === "application/pdf") {
						const pdfURL = generateFileURL(data.value);
						setPdfProps(pdfURL);
					}
				} else {
					// console.log("Not PDF");
				}
			}

			if (data.name === "event_name") {
				if (data.value !== null || data.value !== "") setEventName(data.value);
			}

			if (data.name === "event_date") {
				if (data.value !== null || data.value !== "") setEventDate(data.value);
			}
		});
	};

	useEffect(() => {
		handlePDFViewClick();
	}, [handlePDFViewClick]);

	// console.log("informationFormData => ", informationFormData);
	// console.log("pdf props ==> ", pdfProps);
	// console.log("event date ===> ", eventDate);
	// console.log("event name ===> ", eventName);

	return (
		<div className="dynamic-information-form-container" id="dynamic-information-form-container">
			<Suspense fallback={<div />}>
				<LazyCustomImageDialogWithTitle
					dialogProps={imageDialogProps}
					handleImageDialogClose={handleImageDialogClose}
					eventName={eventName}
					eventDate={eventDate}
				/>
			</Suspense>
			<LazyCustomPdfViewWithTitleDialog
				dialogProps={openPdfViewDialogProps}
				handleClose={handlePdfViewDialogClose}
				pdfFile={pdfProps}
				eventName={eventName}
				eventDate={eventDate}
			/>
			<Grid container spacing={1} className="pf-grid-container">
				<Paper className="pf-paper-container" elevation={3} variant="outlined">
					{informationFormData &&
						informationFormData.map((eachItem, index) => {
							const { label, name, value } = eachItem;
							const isVisible = name === "SSN" ? ssnVisibility : actualSSNVisibility;
							return (
								<Grid item key={index} xs={12} sm={12} md={12} lg={12} xl={12}>
									{name === "event_name" || name === "event_date" ? (
										<Grid container spacing={1} className="pf-label">
											<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
												<div className="pf-label-text" id="pf-label-text">
													{/* {label} */}
													{label}
												</div>
											</Grid>
											<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
												{value === "undefined" || value === null || value == "" ? (
													<div>
														<span style={{ fontSize: "17px" }}>Not Available</span>
														<Tooltip
															title="not provided"
															enterDelay={500}
															leaveDelay={200}
															arrow
														>
															<IconButton>
																<ErrorIcon />
															</IconButton>
														</Tooltip>
													</div>
												) : (
													<TextField
														className="text-field"
														id="first-name-input"
														name={name}
														value={value}
														variant="outlined"
														InputProps={{
															readOnly: true
														}}
														style={{
															pointerEvents: "unset",
															width: "340px",
															borderRadius: 50
														}}
													/>
												)}
											</Grid>
										</Grid>
									) : (
										<Grid container spacing={1} className="pf-label">
											<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
												<div className="pf-label-text" id="pf-label-text">
													{label}
													{/* {name === "SSN" ? "ALT-ID" : label} */}
												</div>
											</Grid>
											<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
												{name === "event_document" ? (
													value === "undefined" || value === null ? (
														<div>
															<span style={{ fontSize: "17px" }}>Not Available</span>
															<Tooltip
																title="Document not provided"
																enterDelay={500}
																leaveDelay={200}
																arrow
															>
																<IconButton>
																	<ErrorIcon />
																</IconButton>
															</Tooltip>
														</div>
													) : (
														<div>
															{value.mimetype === "application/pdf" ||
															value.mimetype === "image/png" ||
															value.mimetype === "image/jpg" ||
															value.mimetype === "image/jpeg" ? (
																<Tooltip
																	title="View Document"
																	enterDelay={500}
																	leaveDelay={200}
																	arrow
																>
																	<IconButton
																		onClick={() => handleViewDocumentClick(value)}
																	>
																		<VisibilityIcon />
																	</IconButton>
																</Tooltip>
															) : (
																<Tooltip
																	title="Sorry, you cannot view the document. However, you can download it"
																	enterDelay={500}
																	leaveDelay={200}
																	arrow
																>
																	<IconButton>
																		<VisibilityOffIcon />
																	</IconButton>
																</Tooltip>
															)}
															<Tooltip
																title="Download Document"
																enterDelay={500}
																leaveDelay={200}
																arrow
															>
																<IconButton
																	onClick={() => downloadFileFromMongoDB(value)}
																>
																	<GetAppRoundedIcon />
																</IconButton>
															</Tooltip>
														</div>
													)
												) : (
													<TextField
														className="text-field"
														id="first-name-input"
														name={name}
														value={
															name === "SSN"
																? formatSSN(value, ssnVisibility)
																: name === "actual_SSN"
																? formatSSN(value, actualSSNVisibility)
																: value
														}
														variant="outlined"
														InputProps={{
															readOnly: true,
															endAdornment: (name === "SSN" || name === "actual_SSN") && (
																<InputAdornment position="end">
																	<Tooltip
																		title={isVisible ? "Hide SSN" : "View SSN"}
																		// title={
																		// 	name === "SSN"
																		// 		? ssnVisibility
																		// 			? "Hide SSN"
																		// 			: "View SSN"
																		// 		: actualSSNVisibility
																		// 		? "Hide SSN"
																		// 		: "View SSN"
																		// }
																		arrow
																	>
																		<IconButton
																			onClick={() => handleViewSSN(name, value)}
																		>
																			{isVisible ? (
																				<VisibilityIcon />
																			) : (
																				<VisibilityOffIcon />
																			)}
																		</IconButton>
																	</Tooltip>
																</InputAdornment>
															)
														}}
														style={{
															pointerEvents: "unset",
															width: "340px",
															borderRadius: 50
														}}
													/>
												)}
											</Grid>
										</Grid>
									)}
								</Grid>
							);
						})}
				</Paper>
			</Grid>
		</div>
	);
};

export default DynamicInformationForm;
